import { useState } from 'react';
import { EnvironmentChooser, Switching } from '../components/EnvironmentSwitcher.js';
import { hasCapability } from '@hub/shared';
import type { Me } from '../lib/session.js';
import { EnvironmentDifferences } from './EnvironmentDifferences.js';

/** Nastavení → Prostředí: totéž co přepínač v záhlaví, jen na celé stránce. */
export function EnvironmentTab({ me }: { me?: Me }): JSX.Element {
  const [target, setTarget] = useState<string | null>(null);
  if (target) return <Switching target={target} />;
  const canSwitch = !!me && hasCapability(me.user.departments, 'switch_environment');
  return (
    <>
      <EnvironmentChooser canSwitch={canSwitch} onSwitched={setTarget} />
      {canSwitch ? <EnvironmentDifferences /> : null}
    </>
  );
}
